import { render } from "./AccountSecurityPage.vue?vue&type=template&id=1d4f66a6&scoped=true"
import script from "./AccountSecurityPage.vue?vue&type=script&lang=js"
export * from "./AccountSecurityPage.vue?vue&type=script&lang=js"

import "./AccountSecurityPage.vue?vue&type=style&index=0&id=1d4f66a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d4f66a6"]])

export default __exports__